import { render, staticRenderFns } from "./SupplierFilters.vue?vue&type=template&id=3cf1b31e&"
import script from "./SupplierFilters.vue?vue&type=script&lang=js&"
export * from "./SupplierFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports